var map = {
	"./pcBlack/introduceIcon1-2.png": 1185,
	"./pcBlack/introduceIcon2-2.png": 5095,
	"./pcBlack/introduceIcon3-2.png": 6218,
	"./pcBlack/introduceIcon4-2.png": 4850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9204;